import Configuration from '@/configuration/configuration'
import BaseEntity from '@/global/dejaVue/baseEntity'
import Database from './database'

export default class LocalSettings extends BaseEntity<Database> {
    
    public languageCode = Configuration.defaultLanguageCode

    public feed(options?: any) {
        if (options) this.languageCode = options.languageCode
        return this
    }
}
